module.exports = __webpack_public_path__ + "static/tourasia-logo-fr-d895c58b784c5e06efb103e8bd0ed7a1.png";